import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import OutcomesGrid from "@/components/OutcomesGrid";
import { CALENDLY_URL } from "@/content";

export default function Outcomes() {
  return (
    <div data-testid="outcomes-page">
      <SEO
        title="Outcomes | Clearer Markets, Better Opportunities | Thrive Business Development"
        description="What clients gain from working with Thrive: sharper market visibility, more qualified opportunities, stronger pipelines, faster market entry, better access to decision-makers and greater commercial confidence."
      />

      <section className="relative overflow-hidden pt-40 pb-16 sm:pt-48 sm:pb-20" data-testid="outcomes-hero">
        <div className="absolute inset-0 dot-grid-bg opacity-50" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="eyebrow mb-6">What better business development should deliver.</p>
            <h1 className="font-display max-w-3xl text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.035em] leading-[1.02] text-white">
              Outcomes
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-8 max-w-2xl text-lg sm:text-xl text-slate-200 leading-snug">
              Clearer markets. Better opportunities. Stronger commercial decisions.
            </p>
            <p className="mt-5 max-w-2xl text-base text-slate-400 leading-relaxed">
              Thrive helps businesses gain greater clarity, build stronger pipelines and focus commercial effort where it has the greatest potential.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24" data-testid="outcomes-cards">
        <OutcomesGrid />
      </section>

      <section className="border-t border-white/10 py-20 lg:py-28" data-testid="outcomes-cta">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
          <Reveal>
            <h2 className="font-display max-w-xl text-2xl sm:text-3xl font-bold tracking-[-0.03em] text-white">
              Which of these matters most to your business right now?
            </h2>
            <p className="mt-4 max-w-xl text-base text-slate-400 leading-relaxed">
              Tell us the market, company or growth challenge you're trying to understand. We'll show you how we can help.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="outcomes-book-call-button"
              className="group inline-flex items-center gap-2 bg-gold px-7 py-4 text-[13px] font-semibold uppercase tracking-[0.18em] text-navy transition-all duration-300 hover:bg-gold-glow"
            >
              Book a Call
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
